import { GudHub } from "./GUDHUB/gudhub.js";

export default GudHub;